import Input, { InputProps } from './Input';

type RequiredProps = 'value' | 'onChange';

type TokenInputProps = Partial<Omit<InputProps, RequiredProps>> &
  Pick<InputProps, RequiredProps>;

const TokenInput = ({
  id = 'apiToken',
  label = 'API Token',
  invalid = false,
  ...props
}: TokenInputProps) => (
  <Input id={id} label={label} invalid={invalid} {...props} />
);

TokenInput.defaultProps = {
  ...Input.defaultProps,
  id: 'apiToken',
  label: 'API Token',
  invalid: false,
};

export default TokenInput;
